<app-page-header
  [pageTitle]="'Detalle de Cultivo Embrionario'"
  [showBreadcrumb]="true"
  [backRoute]="idAgendamiento ? '/pive/' + idAgendamiento : '/pive'"
  [backQueryParams]="idAgendamiento ? { tab: 'cultivo' } : null"
  [backLabel]="'Detalle de Agendamiento'"
  [currentRoute]="'Cultivo'"
/>

<div class="mt-6">
  @if (loading) {
    <app-spinner />
  } @else if (cultivo) {
    @let aspiracion = cultivo.aspiracion_opu ?? cultivo.fertilizacion_in_vitro_detalle?.aspiracion_opu;
    <!-- <app-accordion title="Información del cultivo"> -->
    <app-accordion title="Información del cultivo" [opened]="true">
    <app-card
      [title]="'Información del cultivo'"
      [showEditButton]="canEdit"
      [editable]="editable"
      [editTooltip]="'Editar cultivo'"
      (onEditClick)="editableSwitcher()"
    >
      <div class="mb-4 grid grid-cols-2 gap-3 rounded-lg border border-gray-200 px-4 py-3 text-sm md:grid-cols-4 dark:border-gray-700">
        <div>
          <p class="text-xs text-gray-500 dark:text-gray-400">Orden</p>
          <p class="font-medium text-gray-800 dark:text-white">{{ aspiracion?.orden_ingreso ?? '-' }}</p>
        </div>
        <div>
          <p class="text-xs text-gray-500 dark:text-gray-400">RP donante</p>
          <p class="font-medium text-gray-800 dark:text-white">{{ etiquetaVaca(aspiracion?.animal_donante) }}</p>
        </div>
        <div>
          <p class="text-xs text-gray-500 dark:text-gray-400">Toro</p>
          <p class="font-medium text-gray-800 dark:text-white">{{ aspiracion?.toro_fecundador?.nombre ?? '—' }}</p>
        </div>
        <div>
          <p class="text-xs text-gray-500 dark:text-gray-400">Técnica</p>
          <p class="font-medium text-gray-800 dark:text-white">{{ cultivo.fertilizacion_in_vitro_detalle?.tecnica_fiv?.nombre ?? '—' }}</p>
        </div>
      </div>

      <app-form [formGroup]="cultivoForm">
        <div class="grid grid-cols-1 gap-3 md:grid-cols-2 mb-5">
          <div>
            <app-label for="fecha_inicio">
              Fecha de inicio
            </app-label>
            <app-input-field id="fecha_inicio" formControlName="fecha_inicio" type="date" />
          </div>

          <div>
            <app-label for="param_solucion_id">
              Medio
            </app-label>
            <app-select id="param_solucion_id" formControlName="param_solucion_id" placeholder="Seleccione un medio" [options]="solucionesOptions" searchable />
          </div>

          <!-- Sin observación del cultivo: el valor guardado se conserva al editar.
          <div class="md:col-span-2">
            <app-label for="observacion">
              Observación del cultivo
            </app-label>
            <app-textarea id="observacion" formControlName="observacion" [rows]="3" />
          </div>
          -->
        </div>
      </app-form>

      @if (canEdit && !editable) {
        <app-edition-buttons
          [valid]="cultivoForm.valid"
          [process]="updating"
          [editable]="editable"
          (onCancelClick)="refreshCultivo()"
          (onGoBackClick)="close()"
          (onUpdateClick)="updateCultivo()"
        />
      } @else if (!canEdit) {
        <div class="mt-6 flex justify-end">
          <app-button size="sm" variant="outline" (btnClick)="close()">
            Cerrar
          </app-button>
        </div>
      }
    </app-card>

    </app-accordion>
    <app-card [className]="'mt-6'" [title]="'Planilla de cultivo'">
      <app-planilla-cultivo [cultivo]="cultivo" [idAgendamiento]="idAgendamiento" [canCreate]="canCreate" [canEdit]="canEdit" [canDelete]="canDelete"
        [estadiosOptions]="estadiosOptions" [tecnicasCongelamiento]="tecnicasCongelamiento" [opsPuntosOptions]="opsPuntosOptions"
        [opsColoresOptions]="opsColoresOptions" (saved)="reloadCultivo()" />
    </app-card>
    <!-- Historial de controles oculto: la planilla ya muestra lo que se carga.
    <app-accordion class="block mt-4" title="Historial de controles">
      <app-data-table
        [columns]="controlColumns"
        [data]="cultivo.controles"
        [loading]="false"
        [clickableRows]="false"
      >
        <ng-template appTableCell="dia" let-item>
          {{ item.dia }}{{ item.etapa ? ' - ' + item.etapa : '' }}
        </ng-template>

        <ng-template appTableCell="turno" let-item>
          {{ item.turno || '-' }}
        </ng-template>

        <ng-template appTableCell="estadio" let-item>
          {{ item.estadio_embrionario?.codigo || '-' }}
        </ng-template>

        <ng-template appTableCell="clivaje" let-item>
          {{ item.clivaje === null ? '-' : (item.clivaje ? 'Sí' : 'No') }}
        </ng-template>

        <ng-template appTableCell="acciones" let-item let-index="index">
          <div class="flex items-center gap-x-2.5">
            @if (canDelete) {
              <app-delete-trigger
                [title]="'Eliminar control'"
                [disabled]="deletingControl && (deletingControlId === index)"
                (clickDeleteEvent)="deleteControl(item.id, index)"
              />
            }
          </div>
        </ng-template>
      </app-data-table>
    </app-accordion>
    -->
  } @else {
    <app-card [title]="'No se pudo cargar el cultivo'">
      <p class="text-sm text-gray-600 dark:text-gray-300">
        Verifique que el cultivo exista y que pertenezca al agendamiento seleccionado.
      </p>

      <div class="mt-6 flex justify-end">
        <app-button size="sm" variant="outline" (btnClick)="close()">
          Volver
        </app-button>
      </div>
    </app-card>
  }
</div>
